export default "__VITE_PUBLIC_ASSET__5e2fe407__"